exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".context-menu {\n  position: absolute;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/mouse-menu.vue
 ** module id = 97
 ** module chunks = 0
 **/